import cssClass from './ConfirmationModal.module.css';
import { motion } from 'framer-motion';

const animationVariants = {
  backdrop: {
    hidden: {
      opacity: 0,
      transition: { duration: 0.2 },
    },
    visible: {
      opacity: 1,
      transition: { duration: 0.2 },
    },
  },
  modal: {
    hidden: {
      // y: 20,
      scale: 0.95,
      opacity: 0,
      transition: {
        duration: 0.2,
        ease: 'easeInOut',
      },
    },
    visible: {
      // y: 0,
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.2,
        ease: 'easeOut',
      },
    },
  },
};

const ConfirmationModal = ({
  type = 'general',
  title,
  message,
  onConfirm,
  onCancel,
  additionalProps = {},
}) => {
  if (type === 'revoke-access-confirmation') {
    return (
      <RevokeAccessConfirmationModal
        title={title}
        message={message}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    );
  } else if (type === 'delete-roadmap-confirmation') {
    console.log(additionalProps);
    return (
      <DeleteRoadmapConfirmationModal
        title={title}
        message={message}
        onConfirm={onConfirm}
        onCancel={onCancel}
        additionalProps={additionalProps}
      />
    );
  }
};

const RevokeAccessConfirmationModal = ({
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <motion.div
      className={cssClass['modal-backdrop']}
      onClick={onCancel}
      variants={animationVariants.backdrop}
      initial="hidden"
      animate="visible"
      exit="hidden"
      key="backdrop"
    >
      <motion.div
        className={cssClass['modal']}
        onClick={(e) => e.stopPropagation()}
        variants={animationVariants.modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
        key="modal"
      >
        <div className={cssClass['modal-title']}>{title}</div>
        <p
          className={cssClass['modal-message']}
          dangerouslySetInnerHTML={{ __html: message }}
        />
        <div className={cssClass['button-ct']}>
          <button
            className={`${cssClass['cf-btn']} ${cssClass['cancel']}`}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`${cssClass['cf-btn']} ${cssClass['yes']}`}
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

const DeleteRoadmapConfirmationModal = ({
  title,
  message,
  onConfirm,
  onCancel,
  additionalProps = {},
}) => {
  return (
    <motion.div
      className={cssClass['modal-backdrop']}
      onClick={onCancel}
      variants={animationVariants.backdrop}
      initial="hidden"
      animate="visible"
      exit="hidden"
      key="backdrop"
    >
      <motion.div
        className={cssClass['dr-modal']}
        onClick={(e) => e.stopPropagation()}
        variants={animationVariants.modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
        key="modal"
      >
        <div className={cssClass['dr-modal-title']}>{title}</div>
        <div className={cssClass['dr-button-ct']}>
          <button
            className={`${cssClass['dr-cf-btn']} ${cssClass['dr-yes']}`}
            onClick={onConfirm}
          >
            {additionalProps?.yesMessage || 'Yes'}
          </button>
          <button
            className={`${cssClass['dr-cf-btn']} ${cssClass['dr-cancel']}`}
            onClick={onCancel}
          >
            {additionalProps?.cancelMessage || 'Cancel'}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ConfirmationModal;
